module.exports = __webpack_public_path__ + "static/media/arrow-left.0f20efd4.svg";